var singleSelectOptionIndicatorSlot = 'fx_2d2fb1e5_z29a2g0';

export { singleSelectOptionIndicatorSlot };
//# sourceMappingURL=option.vanilla.mjs.map
